import { useState } from 'react'
import { cn } from '#app/utils/misc.tsx'
import { Button } from './ui/button.tsx'
import { Icon } from './ui/icon.tsx'
import { InputText } from './ui/input-text.tsx'

interface CtaSectionProps {
	className?: string
}

export function CtaSection({ className }: CtaSectionProps) {
	const [email, setEmail] = useState('')

	const handleEmailSubmit = (e: React.FormEvent) => {
		e.preventDefault()
		if (email.trim()) {
			console.log('Newsletter email submitted:', email)
			// TODO: Implement newsletter subscription logic
			setEmail('')
		}
	}

	return (
		<section className={cn('px-4 py-8 md:py-4', className)}>
			<div className="relative overflow-hidden rounded-[24px] bg-blue-900">
				{/* Mobile Layout */}
				<div className="block md:hidden">
					<div className="px-0 py-8">
						<div className="mx-auto max-w-[300px]">
							<div className="flex flex-col items-center gap-8">
								{/* CTA Info */}
								<div className="flex w-full flex-col items-start gap-6">
									{/* CTA Icon */}
									<div className="flex-shrink-0">
										<Icon
											name="buzon-icon"
											className="h-[60px] w-[60px] text-blue-500"
										/>
									</div>

									{/* CTA Text */}
									<div className="w-full">
										<h2 className="font-parkinsans text-lg leading-[30px] font-medium text-white">
											Suscribite al newsletter para recibir novedades sobre
											coberturas y nuevos proyectos
										</h2>
									</div>
								</div>

								{/* CTA Form */}
								<div className="w-full">
									<form
										onSubmit={handleEmailSubmit}
										className="flex w-full flex-col gap-3"
									>
										<div className="w-full">
											<InputText
												type="email"
												value={email}
												onChange={(e) => setEmail(e.target.value)}
												label="Email"
												labelPosition="internal"
												placeholder="Email"
												required
												size="m"
											/>
										</div>

										<Button
											type="submit"
											size="m"
											variant="primary"
											appearance="ghost"
											className="bg-blue-50"
										>
											Suscribirme
										</Button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Desktop Layout */}
				<div className="hidden md:block">
					<div className="p-16">
						<div className="relative z-10 container mx-auto">
							<div className="flex max-w-[1200px] items-center justify-center gap-16">
								{/* CTA Info */}
								<div className="flex items-center gap-6">
									{/* CTA Icon */}
									<div className="flex-shrink-0">
										<Icon
											name="buzon-icon"
											className="h-[94px] w-[94px] text-blue-500"
										/>
									</div>

									{/* CTA Text */}
									<div className="w-[506px]">
										<h2 className="font-parkinsans text-2xl leading-[32px] font-medium text-white">
											Suscribite al newsletter para recibir novedades sobre
											coberturas y nuevos proyectos
										</h2>
									</div>
								</div>

								{/* CTA Form */}
								<div className="flex flex-1 items-center gap-3">
									<form
										onSubmit={handleEmailSubmit}
										className="flex w-full items-center gap-3"
									>
										<div className="flex-1">
											<InputText
												type="email"
												value={email}
												onChange={(e) => setEmail(e.target.value)}
												label="Email"
												labelPosition="internal"
												placeholder="Email"
												required
												size="l"
											/>
										</div>

										<Button
											type="submit"
											size="l"
											variant="primary"
											appearance="ghost"
											className="bg-blue-50"
										>
											Suscribirme
										</Button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default CtaSection
